import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const VectorIcon = forwardRef(({ title = 'Vector Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 6 6" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M6 0L0 6H6V0Z", fill: "#B8B8B8" })));
});
//# sourceMappingURL=vector_icon.js.map